import { createSelector } from 'reselect'

export const getPositions = state => state.views.candidateList_LEGACY.positions.collection
const getPosition = state => state.views.candidateList_LEGACY.positions.member
const getPositionsUtils = state => state.views.candidateList_LEGACY.positions.utils

export const loadingPositions = createSelector([getPositionsUtils], subState => subState.loading)

export const getPositionName = createSelector([getPosition], position => position.name || '')

export const positionListForFavourites = createSelector([getPositions], positions =>
  positions.map(position => ({ id: position.id, name: position.name })),
)
